import React, { useEffect, useState } from "react";
import { TrendingUp, Calendar } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useSEO } from "@/hooks/useSEO";
import { SectionHeading, EmptyState } from "@/components/shared/SectionHeading";
import { RiskBanner } from "@/components/shared/RiskBanner";

export default function Results() {
  const { t } = useLang();
  useSEO("Trading Results", "Transparent weekly and monthly performance reports from INVIXA.");
  const [results, setResults] = useState(null);
  const [filter, setFilter] = useState("all");

  useEffect(() => { api.get("/results").then((r) => setResults(r.data)).catch(() => setResults([])); }, []);
  const filtered = (results || []).filter((r) => filter === "all" || r.type === filter);

  return (
    <div>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <SectionHeading eyebrow={t("results_preview")} title="Performance & Results Reports" subtitle={t("past_performance")} />
        <div className="mt-8 flex gap-2">
          {["all", "weekly", "monthly"].map((f) => (
            <button key={f} onClick={() => setFilter(f)} data-testid={`results-filter-${f}`} className={`px-4 py-2 rounded-full text-sm capitalize border ${filter === f ? "border-brand-cyan text-brand-cyan bg-brand-cyan/10" : "border-white/10 text-slate-400"}`}>{f}</button>
          ))}
        </div>
        <div className="mt-10">
          {results === null ? <div className="text-center text-slate-500 py-20">{t("loading")}</div>
            : filtered.length === 0 ? <EmptyState message="No result reports published yet." icon={TrendingUp} />
            : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filtered.map((r) => (
                  <div key={r.id} className="card-surface hover-glow rounded-2xl overflow-hidden" data-testid={`result-card-${r.id}`}>
                    {r.image_file_id && <img src={fileUrl(r.image_file_id)} alt={r.title} className="w-full h-52 object-cover" />}
                    <div className="p-6">
                      <div className="flex items-center gap-2 text-[11px] font-mono uppercase text-brand-turquoise"><Calendar className="h-3.5 w-3.5" /> {r.type} · {r.date}</div>
                      <h3 className="mt-2 font-display text-lg font-semibold text-white">{r.title}</h3>
                      {r.description && <p className="mt-2 text-sm text-slate-400">{r.description}</p>}
                    </div>
                  </div>
                ))}
              </div>
            )}
        </div>
      </div>
      <RiskBanner />
    </div>
  );
}
